import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';

interface StyledStatusContainerProps {
  isDraft: boolean;
  marginX: string;
}

const StyledStatusContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isDraft',
})<StyledStatusContainerProps>(({ theme, isDraft, marginX }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontWeight: '600',
  justifyContent: 'center',
  padding: theme.spacing(1, 2),
  marginX,
  background: isDraft
    ? theme.palette.alert?.warningBg
    : theme.palette.alert?.successBg,
  color: isDraft
    ? theme.palette.alert?.warningIcon
    : theme.palette.alert?.successIcon,
  minWidth: isDraft ? 'auto' : theme.spacing(13),
}));

const StyledInfoIcon = styled(InfoIcon)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

interface ExistingDraftAllocationStatusProps {
  draft: boolean;
  text?: string;
  marginX?: string;
  tooltipTitle: string;
}

const ExistingDraftAllocationStatus: React.FC<
  ExistingDraftAllocationStatusProps
> = ({ draft, text = 'Yes', marginX = '0', tooltipTitle }) => {
  const content = (
    <StyledStatusContainer isDraft={draft} marginX={marginX}>
      <Typography
        variant="body2"
        fontWeight="bold"
        fontSize="12px"
        paddingTop={0.5}
      >
        {draft ? text : 'No'}
      </Typography>
      {draft && <StyledInfoIcon fontSize="small" />}
    </StyledStatusContainer>
  );

  return draft ? (
    <Tooltip title={tooltipTitle} arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default ExistingDraftAllocationStatus;
